import React, { PropsWithChildren, PureComponent } from 'react';

import ReactCSSTransitionReplace from 'react-css-transition-replace';

import styled from 'styled-components';

import Box from '../../atoms/Box/Box';
import Loader from '../../atoms/Loader/Loader';

import { Status } from '@shared/markup/constants';

const BoxWrapper = styled(Box)`
  .fade-wait-leave,
  .fade-wait-delay-leave {
    opacity: 1;
  }

  .fade-wait-leave.fade-wait-leave-active,
  .fade-wait-delay-leave.fade-wait-delay-leave-active {
    opacity: 0;
    transition: opacity 0.4s ease-in;
  }

  .fade-wait-enter,
  .fade-wait-delay-enter {
    opacity: 0;
  }

  .fade-wait-enter.fade-wait-enter-active,
  .fade-wait-delay-enter.fade-wait-delay-enter-active {
    opacity: 1;
    transition: opacity 0.4s ease-in 0.4s;
  }

  .fade-wait-height {
    transition: height 0.8s ease-in-out;
  }
  .fade-wait-delay-height {
    transition: height 0.4s ease-in-out 0.4s;
  }
`;

type StatusWrapperProps = {
  status: Status;
  onClick?: () => void;
  loaderSize: number;
};

class StatusWrapper extends PureComponent<
  PropsWithChildren<StatusWrapperProps>
> {
  static defaultProps = {
    status: Status.Nothing,
    loaderSize: 3.375,
  };

  state = {
    status: this.props.status,
  };

  loading() {
    this.setState({
      status: Status.Loading,
    });
  }

  nothing() {
    this.setState({
      status: Status.Nothing,
    });
  }

  handleClick = () => {
    if (this.props.onClick) {
      this.loading();
      this.props.onClick();
    }
  };

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.status === this.props.status) {
      return;
    }
    switch (nextProps.status) {
      case Status.Loading:
        this.loading();
        break;
      case Status.Nothing:
        this.nothing();
        break;
    }
  }

  renderTemplate = () => {
    switch (this.state.status) {
      case Status.Loading:
        return <Loader key="key1" size={this.props.loaderSize} />;
      case Status.Nothing:
      default:
        return (
          <div key="key2" onClick={this.handleClick}>
            {this.props.children}
          </div>
        );
    }
  };

  render() {
    return (
      <BoxWrapper>
        <ReactCSSTransitionReplace
          transitionName="fade-wait"
          transitionEnterTimeout={1000}
          transitionLeaveTimeout={400}
        >
          {this.renderTemplate()}
        </ReactCSSTransitionReplace>
      </BoxWrapper>
    );
  }
}

export default StatusWrapper;
